import { SpanNode } from './nodes';

export const NODE_TYPES = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  paragraph: "paragraph",
  preformatted: "preformatted",
  strong: "strong",
  em: "em",
  listItem: "list-item",
  oListItem: "o-list-item",
  list: "group-list-item",
  oList: "group-o-list-item",
  image: "image",
  embed: "embed",
  hyperlink: "hyperlink",
  label: "label",
  span: "span",
};

export const PRIORITIES = {
  [NODE_TYPES.heading1]: 4,
  [NODE_TYPES.heading2]: 4,
  [NODE_TYPES.heading3]: 4,
  [NODE_TYPES.heading4]: 4,
  [NODE_TYPES.heading5]: 4,
  [NODE_TYPES.heading6]: 4,
  [NODE_TYPES.paragraph]: 3,
  [NODE_TYPES.preformatted]: 5,
  [NODE_TYPES.strong]: 6,
  [NODE_TYPES.em]: 6,
  [NODE_TYPES.oList]: 1,
  [NODE_TYPES.list]: 1,
  [NODE_TYPES.listItem]: 1,
  [NODE_TYPES.oListItem]: 1,
  [NODE_TYPES.image]: 1,
  [NODE_TYPES.embed]: 1,
  [NODE_TYPES.hyperlink]: 3,
  [NODE_TYPES.label]: 4,
  [NODE_TYPES.span]: 7,
};
